import React from 'react';
import { Box, Stack } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import {
  StartDateEdit,
  EndDateEdit,
  MaxOccurrencesEdit,
  IsActiveEdit
} from '../fields';

/**
 * LifecycleSection - Contains lifecycle management fields
 */
export const LifecycleSection: React.FC = () => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<CalendarMonth sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Lifecycle Management"
      />
      
      <SectionPaper>
        <Stack spacing={2}>
          <Stack direction="row" gap={2} alignItems="center">
            <StartDateEdit />
            <EndDateEdit />
            <MaxOccurrencesEdit />
          </Stack>
          <IsActiveEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default LifecycleSection;
